module.exports = __webpack_public_path__ + "static/media/operaIcon.eba6a1f1.png";